import { Routes } from '@angular/router';
import { AppVersion } from './v1/modules/auth/dom/app-version';
import { RouteAuth } from './v1/modules/auth/dom/route-auth';
import { AppDom } from './v1/modules/auth/dom/app-dom';

export const routes: Routes = [
  {
    path: AppVersion.v1,
    children: [
      {
        path: AppDom.auth,
        children: [
          { path: RouteAuth.register, loadComponent: () => import('./v1/features/login/register.component').then(m => m.RegisterComponent) },
          { path: RouteAuth.forgotPassword, loadComponent: () => import('./v1/features/login/forgot-password.component').then(m => m.ForgotPasswordComponent) },
          { path: RouteAuth.resetPassword, loadComponent: () => import('./v1/features/login/reset-password.component').then(m => m.ResetPasswordComponent) },
          {
            path: RouteAuth.loginWeb,
            loadComponent: () =>
              import('./v1/features/login/login.component').then((m) => m.LoginComponent),
          },
        ],
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${AppVersion.v1}/${AppDom.auth}/${RouteAuth.loginWeb}`,
  },
  {
    path: '**',
    redirectTo: `${AppVersion.v1}/${AppDom.auth}/${RouteAuth.loginWeb}`,
  },
];
